// Custom Hooks
import { useFlexibleLayout } from "../hooks/useFlexibleLayout"

function Markup(props) {
  const { layout } = props
  return layout && useFlexibleLayout(layout)
}

export { Markup }
